import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import Documentation from './Documentation';
import Question from './Question';
import SubQuestion from './SubQuestion';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { isBundle } from '../../commonCode';
import LeadGenerationContext from '../../../context/LeadGenerationContext';

function Product({
  setItemsAnswer,
  item,
  itemsHandler,
  itemsAnswer,
  disable,
  productData,
  // eslint-disable-next-line react/prop-types
  savedDataFlow,
  // eslint-disable-next-line react/prop-types
  savedItemsAnswer,
  // eslint-disable-next-line react/prop-types
  currentPage,
  productName,
  productAccountType,
  isBundleCompliance = false,
  commonAccountError,
  libreAccountError,
  ahorraAccountError,
}) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const classes = ProductUIStyles(leadGenerationContext?.theme);

  useEffect(() => {
    if (savedDataFlow && !isBundle(productName)) {
      setItemsAnswer(savedItemsAnswer);
    }
  }, [savedDataFlow]);

  const question = { ...item };
  let trueValue = '';

  if (question?.name in itemsAnswer) {
    trueValue = itemsAnswer?.[question?.name];
  }

  const answerHandler = (answer, productQuestion) => {
    itemsHandler(productQuestion, answer);
  };

  const paddingCondition =
    isBundle(productName) && !isBundleCompliance
      ? { padding: '10px !important' }
      : isBundleCompliance
      ? { padding: '0px' }
      : classes.questionContainerProd;
  if (question.subQuestions.length > 0) {
    return (
      <Grid
        container
        size={{ xs: 12 }}
        data-page={currentPage}
        sx={[
          paddingCondition,
          isBundle(leadGenerationContext.productName) &&
            ((libreAccountError && !leadGenerationContext?.productAccountType) ||
              (ahorraAccountError && !leadGenerationContext?.productAccountType) ||
              (commonAccountError && leadGenerationContext?.productAccountType)) && {
              border: '1px solid #D5151F',
              borderRadius: '30px',
            },
        ]}
        className="product-page"
        id={question.name}
      >
        <SubQuestion
          question={question}
          disable={disable}
          answerHandler={answerHandler}
          itemsAnswer={itemsAnswer}
          productData={productData}
          isBundleCompliance={isBundleCompliance}
        />
      </Grid>
    );
  }
  if (!question.subQuestion) {
    if (question.type !== 'Interest') {
      return (
        <Grid
          container
          size={{ xs: 12 }}
          data-page={currentPage}
          // sx={classes.questionContainerProd}
          sx={paddingCondition}
          id={question.name}
          className="product-page"
        >
          <Question
            question={question}
            setItemsAnswer={setItemsAnswer}
            disable={disable}
            answerHandler={answerHandler}
            itemsAnswer={itemsAnswer}
          />
        </Grid>
      );
    }
    return (
      <Grid
        container
        size={{ xs: 12 }}
        // sx={classes.questionContainerWithhold}
        sx={paddingCondition}
        className="product-page"
        id={question.name}
        role="application"
        aria-roledescription={
          question.name === 'WitholdInterest'
            ? t('Interest Withholding Setup', {
                defaultValue: 'Interest Withholding Setup',
              })
            : ''
        }
      >
        <Question
          question={question}
          setItemsAnswer={setItemsAnswer}
          disable={disable}
          answerHandler={answerHandler}
          itemsAnswer={itemsAnswer}
        />
        {(trueValue || JSON.stringify(question.widget) === '{}') && (
          <Documentation
            answerHandler={answerHandler}
            disable={disable}
            itemsAnswer={itemsAnswer}
            question={question}
          />
        )}
      </Grid>
    );
  }
  return <div />;
}

Product.propTypes = {
  setItemsAnswer: PropTypes.func,
  item: PropTypes.object,
  itemsHandler: PropTypes.func,
  itemsAnswer: PropTypes.object,
  disable: PropTypes.bool,
  productData: PropTypes.object,
  productName: PropTypes.string,
  productAccountType: PropTypes.string,
  isBundleCompliance: PropTypes.bool,
  commonAccountError: PropTypes.bool,
  libreAccountError: PropTypes.bool,
  ahorraAccountError: PropTypes.bool,
};
export default Product;
